<div class="content">
    <div class="close-container">
        <button (click)="closeModal()" class="close-button">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="text-container">
        <h1 i18n>Thank you for your order!</h1>
        <p i18n class="orderNr">Order #{{orderNr}}</p>
        <p i18n class="info-text">We will start processing your order right away. You should receive an order confirmation email shortly.
            If you have any questions regarding your order, you are always welcome to <a routerLink="https://ancytree.com/en/kontakta-oss/" target="_blank">contact us.</a></p>
        <img src="./assets/image/ancytree.logo.png" alt="logo" class="logo-image">
        <p i18n class="info-text">You can see your orders by clicking the button below:</p>
        <button i18n class="info-text" routerLink="/dashboard/orders" (click)="dialogRef.close();">VIEW ORDER STATUS</button>
    </div>
</div>